import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "central-background" }
const _hoisted_2 = { class: "py-0 d-flex justify-content-center third-level-nav" }
const _hoisted_3 = { class: "horizontal-nav-bar rounded-top" }
const _hoisted_4 = {
  class: "d-flex bg-white rounded-top",
  id: "solution-tab",
  role: "tablist",
  "aria-orientation": "horizontal"
}
const _hoisted_5 = ["id", "href", "disabled", "onClick"]
const _hoisted_6 = { class: "visit-count px-1 ms-2" }
const _hoisted_7 = {
  class: "tab-content",
  id: "v-pills-tabContent"
}
const _hoisted_8 = { class: "px-3 mb-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnassignedPatientVisitsHomeHealth = _resolveComponent("UnassignedPatientVisitsHomeHealth")!
  const _component_UnassignedPatientVisitsHCHOSPAL = _resolveComponent("UnassignedPatientVisitsHCHOSPAL")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(`nav-link d-flex justify-content-between align-items-center ${
                                _ctx.activeTab === tab.id ? 'active' : ''
                            } ${!_ctx.allowedTabs.includes(tab.id) ? 'disabled-tab' : ''}`),
                id: `v-pills-${tab.id}`,
                "data-bs-toggle": "pill",
                href: _ctx.allowedTabs.includes(tab.id) ? `#v-pills-${tab.id}` : 'javascript:void(0)',
                role: "tab",
                key: tab.id,
                "aria-selected": "true",
                disabled: !_ctx.allowedTabs.includes(tab.id),
                onClick: ($event: any) => (_ctx.handleTabChange(tab))
              }, [
                _createTextVNode(_toDisplayString(tab.name) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_6, _toDisplayString(tab.count), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("section", _hoisted_8, [
            (_ctx.activeTab === _ctx.ApplicationEnum.AgencyCore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_UnassignedPatientVisitsHomeHealth)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.activeTab === _ctx.ApplicationEnum.HomeCare)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_UnassignedPatientVisitsHCHOSPAL, {
                    application: _ctx.ApplicationEnum.HomeCare,
                    "get-unassigned-patients-visits": _ctx.getUnassignedPatientsVisits,
                    "export-unassigned-patients-visits": _ctx.exportUnassignedPatientsVisits
                  }, null, 8 /* PROPS */, ["application", "get-unassigned-patients-visits", "export-unassigned-patients-visits"])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.activeTab === _ctx.ApplicationEnum.AxxessHospiceFE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_UnassignedPatientVisitsHCHOSPAL, {
                    application: _ctx.ApplicationEnum.AxxessHospiceFE,
                    "get-unassigned-patients-visits": _ctx.getUnassignedPatientsVisits,
                    "export-unassigned-patients-visits": _ctx.exportUnassignedPatientsVisits
                  }, null, 8 /* PROPS */, ["application", "get-unassigned-patients-visits", "export-unassigned-patients-visits"])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.activeTab === _ctx.ApplicationEnum.AxxessPalliative)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_UnassignedPatientVisitsHCHOSPAL, {
                    application: _ctx.ApplicationEnum.AxxessPalliative,
                    "get-unassigned-patients-visits": _ctx.getUnassignedPatientsVisits,
                    "export-unassigned-patients-visits": _ctx.exportUnassignedPatientsVisits
                  }, null, 8 /* PROPS */, ["application", "get-unassigned-patients-visits", "export-unassigned-patients-visits"])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}